export const MAIN_SITE_LINK = 'https://www.zoopla.co.uk';

// could we get away without setting these as strings?
export enum LayoutVersion {
    Mobile = 'mobile',
    Desktop = 'desktop'
}

export const MonthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const ADS_MOBILE_BREAKPOINT = 960;

export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 960;
export const LARGE_BREAKPOINT = 1232;
